import { ChangeDetectionStrategy, Component, ElementRef, Input, Renderer2 } from '@angular/core';
import { FikaBeverageAddressCardStackBackgroundViewModel } from './fika-beverage-address-card-stack-background-view-model';
import { CardBackgroundComponent } from '../../card-background.component';
import type { CardData } from '../../../../../../../models/print-cards/card-data';

@Component({
  selector: 'app-fika-beverage-address-card-stack-background',
  templateUrl: './fika-beverage-address-card-stack-background.component.html',
  styleUrls: ['./fika-beverage-address-card-stack-background.component.scss'],
  providers: [FikaBeverageAddressCardStackBackgroundViewModel],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class FikaBeverageAddressCardStackBackgroundComponent extends CardBackgroundComponent {
  constructor(
    public viewModel: FikaBeverageAddressCardStackBackgroundViewModel,
    elementRef: ElementRef,
    renderer2: Renderer2
  ) {
    super(viewModel, elementRef, renderer2);
  }

  @Input() override cardBackground: CardData;
}
